import React from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Alert, Button, MenuItem, Paper, Stack, TextField, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../platform/components/auth/auth-context";

const DETAILS = gql`query PlanyOwnerAuthorization($request:String!){planyOwnerAuthorization(request:$request){careBusinessName businesses{id name url}}}`;
const APPROVE = gql`mutation ApprovePlanyOwnerAuthorization($request:String!,$businessId:ID!){approvePlanyOwnerAuthorization(request:$request,businessId:$businessId)}`;

export default function ConnectPlanyPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { providerUser, logout } = React.useContext(UserContext);
  const request = new URLSearchParams(location.search).get("request") || "";
  const [businessId, setBusinessId] = React.useState("");
  const [error, setError] = React.useState("");
  const details = useQuery(DETAILS, { variables: { request }, skip: !request, fetchPolicy: "network-only" });
  const [approve, { loading }] = useMutation(APPROVE);
  const businesses = details.data?.planyOwnerAuthorization?.businesses || [];
  const selectedId = businessId || (businesses.length === 1 ? businesses[0].id : "");
  const switchAccount = async () => {
    await logout();
    sessionStorage.setItem("redirectAfterLogin", location.pathname + location.search);
    navigate("/login");
  };
  const connect = async () => {
    try {
      const result = await approve({ variables: { request, businessId: selectedId } });
      window.location.assign(result.data.approvePlanyOwnerAuthorization);
    } catch (failure) { setError(failure.message || "Connection could not be approved."); }
  };
  return <Paper sx={{ maxWidth: 600, mx: "auto", my: 4, p: 3 }}><Stack spacing={2}>
    <Typography variant="h5">Connect your Timely365 business to a booking provider</Typography>
    <Typography>Signed in as {providerUser?.email}</Typography>
    {!request && <Alert severity="error">Start this connection from the booking settings of your external provider.</Alert>}
    {details.loading && <Typography>Checking your businesses…</Typography>}
    {(details.error || error) && <Alert severity="error">{details.error?.message || error}</Alert>}
    {details.data && <>
      <Typography>Allow “{details.data.planyOwnerAuthorization.careBusinessName}” in the external provider to create bookings for the Timely business you select.</Typography>
      {!businesses.length ? <Alert severity="warning">This Timely account does not own an active business. Sign in with the owner's account.</Alert> :
        <TextField select label="Your Timely business" value={selectedId} onChange={event => setBusinessId(event.target.value)}>
          {businesses.map(business => <MenuItem key={business.id} value={business.id}>{business.name} ({business.url})</MenuItem>)}
        </TextField>}
      <Button variant="contained" disabled={!selectedId || loading} onClick={connect}>{loading ? "Connecting…" : "Approve connection"}</Button>
    </>}
    <Button onClick={switchAccount}>Use a different Timely account</Button>
    <Button onClick={() => navigate("/biz/bookingtypes")}>Cancel</Button>
  </Stack></Paper>;
}
